module.exports = __webpack_public_path__ + "img/logo-digitalpress.8dd6265c.png";